import React, { useState, useEffect } from 'react';
import {
  Button,
  Form,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import Header from '~/Components/Header/Header';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { default as Selector } from 'react-select';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {
  salvarReservasMapaEmpreendimento,
  buscarClassificacoesAutoatendimento,
} from '~/Services/Service';
import { toast } from 'react-toastify';
import { isAmbienteProducao } from '~/Pages/Vendas/helpers';
import Hint from '~/Components/Hint/Hint';

const TelaMapaEmpreendimento = ({
  empreendimentoId,
  empreendimentoData,
  nome_familia,
  voltarParaLista,
}) => {
  const [classificacaoOptions, setClassificacaoOptions] = useState([]);
  const ehProducao = isAmbienteProducao();

  useEffect(() => {
    if (ehProducao) return;
    const carregarClassificacoes = async () => {
      try {
        const data = await buscarClassificacoesAutoatendimento();
        if (data && Array.isArray(data)) {
          const options = data.map(item => ({
            value: item.codigo,
            label: item.descricao,
          }));
          setClassificacaoOptions(options);
        }
      } catch (error) {
        console.error('Erro ao carregar classificações:', error);
      }
    };
    carregarClassificacoes();
  }, []);

  const flexibilidadeOptions = [
    { value: true, label: 'Mais flexível' },
    { value: false, label: 'Menos flexível' },
  ];

  const initialValues = {
    tempoReserva: (empreendimentoData && empreendimentoData.tempo) || 0,
    qtdReservasPorCorretor:
      (empreendimentoData && empreendimentoData.limite) || 0,
    tempoExtraEstorno:
      (empreendimentoData && empreendimentoData.tempo_extra_estorno) || 0,
    transfReserva:
      (empreendimentoData && empreendimentoData.transf_res === 'S'
        ? 'sim'
        : 'nao') || 'nao',
    tempoLiberacao:
      (empreendimentoData && empreendimentoData.tempo_liberacao) || 0,
    limiteFluxoProspectos:
      (empreendimentoData && empreendimentoData.limite_fluxo_prospectos) || 0,
    liberaReserva:
      (empreendimentoData && empreendimentoData.libera_reserva === 'S'
        ? 'sim'
        : 'nao') || 'nao',
    usarVPs:
      (empreendimentoData &&
        (empreendimentoData.exibe_valor_presente_venda === true ||
          empreendimentoData.exibe_valor_presente_venda === 'S')) ||
      false,
    exibirNaoConcomitantes:
      (empreendimentoData &&
        (empreendimentoData.habilita_intermediarias_nao_concomitantes ===
          true ||
          empreendimentoData.habilita_intermediarias_nao_concomitantes ===
            'S')) ||
      false,
    limitePorCorretor:
      (empreendimentoData && empreendimentoData.limite_fila_corretor) || 0,
    limitePorProspecto:
      (empreendimentoData && empreendimentoData.limite_fila_prospecto) || 0,          
    descontoMaximo:
          (empreendimentoData && empreendimentoData.desconto_maximo) || 0,
    classificacao:
      (empreendimentoData &&
        empreendimentoData.codigo_empreendimento_tipo_classificacao) ||
      null,
    flexibilidade:
      empreendimentoData &&
      empreendimentoData.empreendimento_mais_flexivel != null
        ? empreendimentoData.empreendimento_mais_flexivel
        : null,
    solicitacaoAutomaticaDocDigital:
      empreendimentoData &&
      empreendimentoData.solicitacao_automatica_doc_digital != null
        ? empreendimentoData.solicitacao_automatica_doc_digital
        : 0,
    codigoFormaEnvioDocumentoDigital:
      empreendimentoData &&
      empreendimentoData.codigo_forma_envio_documento_digital != null
        ? empreendimentoData.codigo_forma_envio_documento_digital
        : null,
  };

  const simNaoOptions = [
    { value: 'nao', label: 'Não' },
    { value: 'sim', label: 'Sim' },
  ];

  const solicitacaoAutomaticaOptions = [
    { value: 0, label: 'Não' },
    { value: 1, label: 'Sim' },
  ];

  const canalNotificacaoOptions = [
    { value: 1, label: 'Email' },
    { value: 2, label: 'WhatsApp' },
  ];

  const validationSchema = Yup.object().shape({
    tempoReserva: Yup.number()
      .typeError('Deve ser um número')
      .required('Obrigatório')
      .min(0, 'Min 0')
      .integer('Inteiro'),
    qtdReservasPorCorretor: Yup.number()
      .typeError('Deve ser um número')
      .required('Obrigatório')
      .min(0, 'Min 0')
      .integer('Inteiro'),
    tempoExtraEstorno: Yup.number()
      .typeError('Deve ser um número')
      .required('Obrigatório')
      .min(0, 'Min 0')
      .integer('Inteiro'),
    transfReserva: Yup.string().required('Obrigatório'),
    tempoLiberacao: Yup.number()
      .typeError('Deve ser um número')
      .required('Obrigatório')
      .min(0, 'Min 0')
      .integer('Inteiro'),
    limiteFluxoProspectos: Yup.number()
      .typeError('Deve ser um número')
      .required('Obrigatório')
      .min(0, 'Min 0')
      .integer('Inteiro'),
    liberaReserva: Yup.string().required('Obrigatório'),
    usarVPs: Yup.boolean(),
    descontoMaximo: Yup.number()
    .typeError('Deve ser um número')
    .min(0, "Minimo 0%")
    .max(100, "Maximo 100%"),
    exibirNaoConcomitantes: Yup.boolean(),
    limitePorCorretor: Yup.number()
      .typeError('Deve ser um número')
      .required('Obrigatório')
      .min(0, 'Min 0')
      .integer('Inteiro'),
    limitePorProspecto: Yup.number()
      .typeError('Deve ser um número')
      .required('Obrigatório')
      .min(0, 'Min 0')
      .integer('Inteiro'),
    codigoFormaEnvioDocumentoDigital: Yup.number()
      .nullable()
      .when('solicitacaoAutomaticaDocDigital', {
        is: 1,
        then: Yup.number()
          .nullable()
          .test(
            'canal-obrigatorio',
            'Selecione o canal de notificação',
            value => value === 1 || value === 2
          ),
      }),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        familia: empreendimentoId,
        tempo: values.tempoReserva,
        limite: values.qtdReservasPorCorretor,
        tempo_extra_estorno: values.tempoExtraEstorno,
        transf_res: values.transfReserva === 'sim' ? 'S' : 'N',
        tempo_liberacao: values.tempoLiberacao,
        limite_fluxo_prospectos: values.limiteFluxoProspectos,
        libera_reserva: values.liberaReserva === 'sim' ? 'S' : 'N',
        exibe_valor_presente_venda: values.usarVPs,
        habilita_intermediarias_nao_concomitantes:
          values.exibirNaoConcomitantes,
        limite_fila_corretor: values.limitePorCorretor,
        limite_fila_prospecto: values.limitePorProspecto,
        codigo_empreendimento_tipo_classificacao: values.classificacao,
        empreendimento_mais_flexivel: values.flexibilidade,
        solicitacao_automatica_doc_digital:
          values.solicitacaoAutomaticaDocDigital,
        codigo_forma_envio_documento_digital:
          values.solicitacaoAutomaticaDocDigital === 1
            ? values.codigoFormaEnvioDocumentoDigital
            : 0,
        desconto_maximo: values.descontoMaximo,
      };

      await salvarReservasMapaEmpreendimento(payload);
      toast.success('Dados salvos com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar:', error);
      toast.error('Erro ao salvar os dados.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-white my-3">
      <Header title="Mapa do empreendimento" />
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <FormikForm>
            <Row className="px-3 my-3">
              {/* Coluna da Esquerda - Reservas */}
              <Col xs={12} lg={6} className="mb-3 mb-lg-0">
                <Card className="h-100">
                  <Card.Header className="bg-light">
                    <h5 className="mb-0">Reservas</h5>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      {/* Coluna 1 de campos */}
                      <Col xs={12} md={6}>
                        <div className="form-group mb-2">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>Duração da reserva em minutos</Tooltip>
                            }
                          >
                            <label
                              className="small mb-1"
                              style={{ cursor: 'help' }}
                            >
                              Tempo Reserva (min)
                            </label>
                          </OverlayTrigger>
                          <Field
                            name="tempoReserva"
                            type="number"
                            className="form-control form-control-sm"
                            min={0}
                          />
                          <ErrorMessage
                            name="tempoReserva"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        <div className="form-group mb-2">
                          <label className="small mb-1">
                            Tempo Extra Estorno
                          </label>
                          <Field
                            name="tempoExtraEstorno"
                            type="number"
                            className="form-control form-control-sm"
                            min={0}
                          />
                          <ErrorMessage
                            name="tempoExtraEstorno"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        <div className="form-group mb-2">
                          <label className="small mb-1">Tempo Liberação</label>
                          <Field
                            name="tempoLiberacao"
                            type="number"
                            className="form-control form-control-sm"
                            min={0}
                          />
                          <ErrorMessage
                            name="tempoLiberacao"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        <div className="form-group mb-2">
                          <label className="small mb-1">Libera Reserva</label>
                          <Field name="liberaReserva">
                            {({ field, form }) => (
                              <Selector
                                options={simNaoOptions}
                                styles={customStyles}
                                components={{ DropdownIndicator }}
                                value={simNaoOptions.find(
                                  option => option.value === field.value
                                )}
                                onChange={option =>
                                  form.setFieldValue(field.name, option.value)
                                }
                                onBlur={() =>
                                  form.setFieldTouched(field.name, true)
                                }
                                placeholder="Selecione..."
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="liberaReserva"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        <div className="form-group mb-2">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                Ao marcar mostra os valores VP das parcelas no
                                resumo do financiamento
                              </Tooltip>
                            }
                          >
                            <label
                              className="small mb-1 d-block"
                              style={{ cursor: 'help' }}
                            >
                              Usar VPs
                            </label>
                          </OverlayTrigger>
                          <Field name="usarVPs">
                            {({ field, form }) => (
                              <Form.Check
                                type="switch"
                                id="switch-usar-vps"
                                checked={field.value}
                                onChange={e =>
                                  form.setFieldValue(
                                    field.name,
                                    e.target.checked
                                  )
                                }
                                onBlur={() =>
                                  form.setFieldTouched(field.name, true)
                                }
                              />
                            )}
                          </Field>
                        </div>
                      </Col>

                      {/* Coluna 2 de campos */}
                      <Col xs={12} md={6}>
                        <div className="form-group mb-2">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                Limite de reserva por corretor para esse
                                empreendimento
                              </Tooltip>
                            }
                          >
                            <label
                              className="small mb-1"
                              style={{ cursor: 'help' }}
                            >
                              Qtd. Reservas/Corretor
                            </label>
                          </OverlayTrigger>
                          <Field
                            name="qtdReservasPorCorretor"
                            type="number"
                            className="form-control form-control-sm"
                            min={0}
                          />
                          <ErrorMessage
                            name="qtdReservasPorCorretor"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        <div className="form-group mb-2">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                Permite usuários com característica transferir
                                reservas para um corretor
                              </Tooltip>
                            }
                          >
                            <label
                              className="small mb-1"
                              style={{ cursor: 'help' }}
                            >
                              Transf. Reserva
                            </label>
                          </OverlayTrigger>
                          <Field name="transfReserva">
                            {({ field, form }) => (
                              <Selector
                                options={simNaoOptions}
                                styles={customStyles}
                                components={{ DropdownIndicator }}
                                value={simNaoOptions.find(
                                  option => option.value === field.value
                                )}
                                onChange={option =>
                                  form.setFieldValue(field.name, option.value)
                                }
                                onBlur={() =>
                                  form.setFieldTouched(field.name, true)
                                }
                                placeholder="Selecione..."
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="transfReserva"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        <div className="form-group mb-2">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                Limite de prospectos em atendimento por corretor
                                no empreendimento
                              </Tooltip>
                            }
                          >
                            <label
                              className="small mb-1"
                              style={{ cursor: 'help' }}
                            >
                              Limite Fluxo Prospectos
                            </label>
                          </OverlayTrigger>
                          <Field
                            name="limiteFluxoProspectos"
                            type="number"
                            className="form-control form-control-sm"
                            min={0}
                          />
                          <ErrorMessage
                            name="limiteFluxoProspectos"
                            component="div"
                            className="text-danger small"
                          />
                        </div>
                        <div className='form-group mb-2'>
                          <OverlayTrigger
                            placement='top'
                            overlay={
                              <Tooltip>
                                Limite máximo de desconto na venda, definida por empreendimento
                              </Tooltip>
                            }
                          >
                            <label className='small mb-1'>
                              Desconto Máximo
                            </label>
                          </OverlayTrigger>
                          <Field 
                            name="descontoMaximo"
                            type="number"
                            className="form-control form-control-sm"
                            min={0}
                            max={100}                          
                          />
                          <ErrorMessage 
                            name='descontoMaximo'
                            component="div"
                            className='text-danger small'
                          />
                        </div>

                        <div className="form-group mb-2">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                Ao marcar mostra a opção de parcelas
                                intermediárias mensais para não acontecerem no
                                mesmo mês
                              </Tooltip>
                            }
                          >
                            <label
                              className="small mb-1 d-block"
                              style={{ cursor: 'help' }}
                            >
                              Exibir Não Concomitantes
                            </label>
                          </OverlayTrigger>
                          <Field name="exibirNaoConcomitantes">
                            {({ field, form }) => (
                              <Form.Check
                                type="switch"
                                id="switch-exibir-nao-concomitantes"
                                checked={field.value}
                                onChange={e =>
                                  form.setFieldValue(
                                    field.name,
                                    e.target.checked
                                  )
                                }
                                onBlur={() =>
                                  form.setFieldTouched(field.name, true)
                                }
                              />
                            )}
                          </Field>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>

              <Col xs={12} lg={6}>
                {/* Botão Alterar Contrato */}
                {empreendimentoData && (
                  <div className="text-center mb-3">
                    <Button
                      as="a"
                      href={`/contrato/empreendimento/${empreendimentoId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="outline-danger"
                      size="sm"
                      className="w-100 w-md-auto"
                    >
                      {`Alterar contrato: ${empreendimentoId} - ${nome_familia}`}
                    </Button>
                  </div>
                )}

                {/* Card Fila do Lote */}
                <Card>
                  <Card.Header className="bg-light">
                    <h5 className="mb-0">Fila do Lote</h5>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col xs={6}>
                        <div className="form-group mb-0">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                Limite da fila para cada corretor (multiplicado
                                pela quantidade permitida por prospecto no campo
                                ao lado)
                              </Tooltip>
                            }
                          >
                            <label
                              className="small mb-1"
                              style={{ cursor: 'help' }}
                            >
                              Limite por corretor
                            </label>
                          </OverlayTrigger>
                          <Field
                            name="limitePorCorretor"
                            type="number"
                            min={0}
                            className="form-control form-control-sm"
                          />
                          <ErrorMessage
                            name="limitePorCorretor"
                            component="div"
                            className="text-danger small"
                          />
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="form-group mb-0">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                Limite da fila para cada prospecto
                              </Tooltip>
                            }
                          >
                            <label
                              className="small mb-1"
                              style={{ cursor: 'help' }}
                            >
                              Limite por prospecto
                            </label>
                          </OverlayTrigger>
                          <Field
                            name="limitePorProspecto"
                            type="number"
                            min={0}
                            className="form-control form-control-sm"
                          />
                          <ErrorMessage
                            name="limitePorProspecto"
                            component="div"
                            className="text-danger small"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {/* Card Classificação Empreendimento */}
                {!ehProducao && (
                  <Card className="mt-3">
                    <Card.Header className="bg-light">
                      <h5 className="mb-0">Classificação do Empreendimento</h5>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col xs={12} md={6}>
                          <div className="form-group mb-2 mb-md-0">
                            <label className="small mb-1">Classificação</label>
                            <Field name="classificacao">
                              {({ field, form }) => (
                                <Selector
                                  options={classificacaoOptions}
                                  styles={customStyles}
                                  components={{ DropdownIndicator }}
                                  value={
                                    classificacaoOptions.find(
                                      option => option.value === field.value
                                    ) || null
                                  }
                                  onChange={option =>
                                    form.setFieldValue(
                                      field.name,
                                      option ? option.value : null
                                    )
                                  }
                                  onBlur={() =>
                                    form.setFieldTouched(field.name, true)
                                  }
                                  placeholder="Selecione..."
                                  isClearable
                                />
                              )}
                            </Field>
                          </div>
                        </Col>
                        <Col xs={12} md={6}>
                          <div className="form-group mb-2 mb-md-0">
                            <label className="small mb-1">Flexibilidade</label>
                            <Field name="flexibilidade">
                              {({ field, form }) => (
                                <Selector
                                  options={flexibilidadeOptions}
                                  styles={customStyles}
                                  components={{ DropdownIndicator }}
                                  value={
                                    flexibilidadeOptions.find(
                                      option => option.value === field.value
                                    ) || null
                                  }
                                  onChange={option =>
                                    form.setFieldValue(
                                      field.name,
                                      option ? option.value : null
                                    )
                                  }
                                  onBlur={() =>
                                    form.setFieldTouched(field.name, true)
                                  }
                                  placeholder="Selecione..."
                                  isClearable
                                />
                              )}
                            </Field>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                )}

                <Card className="mt-3">
                  <Card.Header className="bg-light">
                    <h5 className="mb-0">Documento Digital</h5>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col xs={12} md={6}>
                        <div className="form-group mb-2 mb-md-0">
                          <label className="small mb-1 d-inline-flex align-items-center">
                            Solicitação automática
                            <Hint
                              title="Solicitação automática"
                              content="Ao finalizar a venda, o documento será solicitado, aprovado e será feito o upload para a plataforma de documento digital."
                              size={14}
                              placement="top"
                            />
                          </label>
                          <Field name="solicitacaoAutomaticaDocDigital">
                            {({ field, form }) => (
                              <Selector
                                options={solicitacaoAutomaticaOptions}
                                styles={customStyles}
                                components={{ DropdownIndicator }}
                                value={
                                  solicitacaoAutomaticaOptions.find(
                                    option => option.value === field.value
                                  ) || null
                                }
                                onChange={option => {
                                  const novoValor = option ? option.value : 0;
                                  form.setFieldValue(field.name, novoValor);
                                  if (novoValor !== 1) {
                                    form.setFieldValue(
                                      'codigoFormaEnvioDocumentoDigital',
                                      null
                                    );
                                  }
                                }}
                                onBlur={() =>
                                  form.setFieldTouched(field.name, true)
                                }
                                placeholder="Selecione..."
                              />
                            )}
                          </Field>
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group mb-2 mb-md-0">
                          <label className="small mb-1 d-inline-flex align-items-center">
                            Canal de notificação ClickSign
                            <Hint
                              title="Canal de notificação ClickSign"
                              content="Canal por onde o comprador irá receber a notificação de contrato para assinatura."
                              size={14}
                              placement="top"
                            />
                          </label>
                          <Field name="codigoFormaEnvioDocumentoDigital">
                            {({ field, form }) => {
                              const habilitado =
                                form.values.solicitacaoAutomaticaDocDigital ===
                                1;
                              return (
                                <Selector
                                  options={canalNotificacaoOptions}
                                  styles={customStyles}
                                  components={{ DropdownIndicator }}
                                  value={
                                    canalNotificacaoOptions.find(
                                      option => option.value === field.value
                                    ) || null
                                  }
                                  onChange={option =>
                                    form.setFieldValue(
                                      field.name,
                                      option ? option.value : null
                                    )
                                  }
                                  onBlur={() =>
                                    form.setFieldTouched(field.name, true)
                                  }
                                  placeholder="Selecione..."
                                  isDisabled={!habilitado}
                                  isClearable
                                />
                              );
                            }}
                          </Field>
                          <ErrorMessage
                            name="codigoFormaEnvioDocumentoDigital"
                            component="div"
                            className="text-danger small"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* Botões de Ação Centralizados */}
            <Row className="px-3">
              <Col xs={12}>
                <div className="d-flex flex-column flex-sm-row justify-content-center my-3">
                  <button
                    type="submit"
                    className="btn btn-success mb-2 mb-sm-0 mr-sm-2"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={voltarParaLista}
                  >
                    Cancelar
                  </button>
                </div>
              </Col>
            </Row>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};

export default TelaMapaEmpreendimento;
